/** Number of distinct 2-card combos in a 52-card deck: C(52,2). */
export const COMBO_COUNT = 1326;
/** Combo index for two DISTINCT cards, order-independent. idx = hi*(hi-1)/2 + lo (hi > lo). */
export const comboIndex = (x, y) => {
    const a = x;
    const b = y;
    if (a === b)
        throw new RangeError(`a combo needs two distinct cards, got ${a} twice`);
    const hi = a > b ? a : b;
    const lo = a > b ? b : a;
    return (hi * (hi - 1)) / 2 + lo;
};
/** idx → the two CardIndexes [hi, lo] (hi > lo). Built once at load. */
export const COMBO_CARDS = (() => {
    const out = new Array(COMBO_COUNT);
    for (let hi = 1; hi < 52; hi++) {
        for (let lo = 0; lo < hi; lo++) {
            out[(hi * (hi - 1)) / 2 + lo] = [hi, lo];
        }
    }
    return out;
})();
/** card (0..51) → the 51 combo indices that contain it. Built once; drives fast removal. */
export const CARD_COMBOS = (() => {
    const out = Array.from({ length: 52 }, () => []);
    for (let idx = 0; idx < COMBO_COUNT; idx++) {
        const [hi, lo] = COMBO_CARDS[idx];
        out[hi].push(idx);
        out[lo].push(idx);
    }
    return out;
})();
/** Decode a combo index back to its two cards. */
export const decodeCombo = (idx) => {
    if (idx < 0 || idx >= COMBO_COUNT || !Number.isInteger(idx)) {
        throw new RangeError(`combo index out of range: ${idx}`);
    }
    return COMBO_CARDS[idx];
};
/** A fresh all-zero WeightedRange (nothing in range, nothing removed). */
export const emptyRange = () => ({
    weights: new Float32Array(COMBO_COUNT),
    removed: new Uint16Array(0),
});
/** Deep copy - every mutating range op returns a fresh range and never touches its input. */
export const cloneRange = (r) => ({
    weights: new Float32Array(r.weights),
    removed: new Uint16Array(r.removed),
});
/** Total weight in a range (Σ weights). Denominator for pctOfRange and the perceived summary. */
export const totalWeight = (r) => {
    let sum = 0;
    for (let i = 0; i < COMBO_COUNT; i++)
        sum += r.weights[i];
    return sum;
};
/** Count of combos with weight above a small epsilon (live combos), for coverage checks/tests. */
export const liveComboCount = (r, epsilon = 1e-6) => {
    let n = 0;
    for (let i = 0; i < COMBO_COUNT; i++)
        if (r.weights[i] > epsilon)
            n++;
    return n;
};
//# sourceMappingURL=combos.js.map